import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduce } from 'lodash';

import NoOp from './NoOp';
import Segment from './Segment';

export const ProviderMethods = ['alias', 'group', 'identify', 'page', 'track', 'reset'];

// What does an analytics provider look like
export const ProviderProps = PropTypes.shape(
  reduce(
    ProviderMethods,
    (ret, method) => {
      ret[method] = PropTypes.func.isRequired;
      return ret;
    },
    {},
  ),
);

export const AnalyticsContext = React.createContext({
  analytics: reduce(
    ProviderMethods,
    (ctx, key) => {
      ctx[key] = undefined;
      return ctx;
    },
    {},
  ),
});

function buildAnalytics(props) {
  if (props.ssr || !process.env.REACT_APP_SEGMENT_KEY || process.env.REACT_APP_DEV) {
    return NoOp();
  }
  return Segment(process.env.REACT_APP_SEGMENT_KEY);
}

export class AnalyticsProvider extends PureComponent {
  render() {
    return (
      <AnalyticsContext.Provider value={{ analytics: () => buildAnalytics(this.props) }}>{this.props.children}</AnalyticsContext.Provider>
    );
  }
}

export default AnalyticsProvider;
